import { AuthLogType, IpAddress, } from "../value-objects";
import { BaseLogRecord, } from "./base-log-record";
export class AuthLogRecord extends BaseLogRecord {
    constructor(values) {
        super(values);
    }
    static newFailedAttempt(ip, accountName) {
        const args = {
            ...AuthLogRecord.setBasic(),
            type: new AuthLogType({ type: "failedAttempt" }),
            ip: new IpAddress({ ip }),
            accountName: accountName,
        };
        return new AuthLogRecord(args);
    }
    static newFailed(ip, user) {
        const args = {
            ...AuthLogRecord.setBasic(),
            type: new AuthLogType({ type: "loginFailed" }),
            ip: new IpAddress({ ip }),
            accountName: user.accountName,
            userId: user.id,
            userRole: user.userRole,
        };
        return new AuthLogRecord(args);
    }
    static newSuccess(ip, user) {
        const args = {
            ...AuthLogRecord.setBasic(),
            type: new AuthLogType({ type: "loginSuccess" }),
            ip: new IpAddress({ ip }),
            accountName: user.accountName,
            userId: user.id,
            userRole: user.userRole,
        };
        return new AuthLogRecord(args);
    }
    static newLogout(ip, user) {
        const args = {
            ...AuthLogRecord.setBasic(),
            type: new AuthLogType({ type: "logout" }),
            ip: new IpAddress({ ip }),
            accountName: user.accountName,
            userId: user.id,
            userRole: user.userRole,
        };
        return new AuthLogRecord(args);
    }
    static newRefreshSuccess(ip, user) {
        const args = {
            ...AuthLogRecord.setBasic(),
            type: new AuthLogType({ type: "refreshSuccess" }),
            ip: new IpAddress({ ip }),
            accountName: user.accountName,
            userId: user.id,
            userRole: user.userRole,
        };
        return new AuthLogRecord(args);
    }
    static newRefreshFailed(ip, user) {
        const args = {
            ...AuthLogRecord.setBasic(),
            type: new AuthLogType({ type: "refreshFailed" }),
            ip: new IpAddress({ ip }),
            accountName: user.accountName,
            userId: user.id,
            userRole: user.userRole,
        };
        return new AuthLogRecord(args);
    }
}
//# sourceMappingURL=auth-log-record.js.map